import { FeatureType, GetAddOnResponse } from '../../types';
import { LitElement, css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators';
import { isDefined, undefinedIfEmpty } from '../../helpers/utils';

@customElement('admin-fragment-holder')
export class AdminFragmentHolder extends LitElement {
    amplitude_callsite: string = 'Admin Fragment Holder';

    @property()
    title: string = 'New Drawer';

    @property()
    description: string = 'New Description';

    @property()
    helpLink?: string;

    @property()
    marketingSiteLink?: string;

    @property()
    addOn?: GetAddOnResponse;

    @property()
    fullWidth: boolean = false;

    @state()
    feature_entitlements: FeatureType[] = [];

    @state()
    showVideo: boolean = false;

    toggleVideo() {
        // open video in new tab
        window.open(this.addOn?.video_demo_link, '_blank');
    }

    toggleMarketingSite() {
        // open marketing site in new tab
        window.open(this.addOn?.marketing_page_link, '_blank');
    }

    close() {
        this.dispatchEvent(new CustomEvent('close-fragment'));
    }

    protected render() {
        return html`
            <div class='closeButton' @click="${this.close}">
                <mwc-icon>close</mwc-icon>
            </div>
            <div class="titleArea">
                <h1 class="title">
                    ${this.title}
                </h1>
                <p class="info-paragraph">
                    ${this.description}
                </p>
            </div>
            <div class="help-container">
                ${isDefined(this.addOn?.marketing_page_link) ? html`
                    <form-button
                        variant="outline"
                        size="xs"
                        class="buttonSection ${isDefined(this.addOn?.marketing_page_link) ? 'hidden' : ''}"
                        @click="${this.toggleMarketingSite}">
                        <mwc-icon class="shareButtonIcon">web</mwc-icon>
                        <span class="buttonText">About Feature</span>
                    </form-button>
                ` : ''}
                ${isDefined(this.addOn?.video_demo_link) ? html`
                    <form-button
                        variant="outline"
                        size="xs"
                        class="buttonSection ${isDefined(undefinedIfEmpty(this.addOn?.video_demo_link)) ? 'hidden' : ''}"
                        @click="${this.toggleVideo}">
                        <mwc-icon class="shareButtonIcon">play_circle</mwc-icon>
                        <span class="buttonText">Demo Video</span>
                    </form-button>
                ` : ''}
                ${isDefined(this.addOn?.documentation_link) ? html`
                    <form-button
                        variant="outline"
                        size="xs"
                        class="buttonSection ${isDefined(this.addOn?.documentation_link) ? 'hidden' : ''}"
                        @click="${this.toggleVideo}">
                        <mwc-icon class="shareButtonIcon">article</mwc-icon>
                        <span class="buttonText">Documentation</span>
                    </form-button>
                ` : ''}
            </div>
            <div class="container">
                <slot></slot>
            </div>
            <error-toast id="errorToast"></error-toast>
        `;
    }

    static get styles() {
        return css`
            :host {
                display: flex;
                flex-direction: column;
                height: 100%;
                overflow-y: auto;
                box-sizing: border-box;
            }

            .shareButtonIcon {
                --mdc-icon-size: 0.8rem;
            }

            .closeButton {
                position: absolute;
                top: 0;
                right: 0;
                padding: 10px;
                cursor: pointer;
                z-index:2;
            }

            .container {
                flex-direction: column;
                height: 100%;
                overflow: hidden auto;
                box-sizing: border-box;
                padding: 5px 0 5px 20px;
                flex: 1;
                position: relative; /* Ensure the container is positioned */
            }

            :host {
                position: relative;
                left: -100%; /* Start off-screen to the left */
                animation: slide-in 0.5s forwards 0.5s; /* Apply the slide-in animation */
                height: 100%;
            }

            @keyframes slide-in {
                to {
                    left: 0; /* Move to the final position */
                }
            }

            .titleArea {
                display: flex;
                justify-content: center;
                align-items: flex-start;
                flex-direction: column;
                border-bottom: 1px solid var(--theme-border-color);
                padding: 10px 15px;
            }

            .title {
                color: var(--main-primary-color);
                text-align: left;
                font-size: 1.1rem;
                font-weight: 660;
                line-height: 130%;
                margin: 5px 0;
            }

            .info-paragraph {
                color: var(--theme-input-color);
                margin-top: 0;
                margin-bottom: 0;
            }

            .sub-title {
                margin-bottom: 5px;
                color: var(--theme-input-color);
                font-size: 16px;
            }

            .buttonSection {
                background-color: var(--theme-white-color);
            }

            .help-container {
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                align-items: center;
                padding-right: 10px;
                gap: 5px;
                position: relative;
                top: -5px;
                height: 10px;
                z-index: 2;
            }

            .buttonText {
                display: none;
                opacity: 0;
                transition: visibility 0s, opacity 0.5s linear;
                margin-left: 5px;
            }

            form-button:hover .buttonText {
                display: inline;
                visibility: visible;
                opacity: 1;
            }

            /* width */
            .container::-webkit-scrollbar {
                width: 5px;
            }

            /* Track */
            .container::-webkit-scrollbar-track {
                background: var(--theme-light-scrollbar-color);
            }

            /* Handle */
            .container::-webkit-scrollbar-thumb {
                background: var(--main-moon-color);
            }

            .tags-categories__header {
                color: var(--main-primary-color);
                margin-top: 1rem;
            }

            @media only screen and (max-width: 550px) {
                .tags-categories__header {
                    margin: 0.2em 0;
                }
            }
        `;
    }
}